/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger,
        breakpointMaxM = 768,
        resizeTimer;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');
        breakpointMaxM = 768;

        let mobileMenuExtras;
        const menu = new Mmenu(mobileMenuSelector, {
            // options
            'extensions': [
                'position-right',
                'pagedim-black',
                'border-full',
                'theme-dark',
                'fx-menu-slide'
            ],
            hooks: {
                "openPanel:before": (panel) => {
                    const parser = new DOMParser();
                    const panelContent = parser.parseFromString(panel.innerHTML, "text/html");
                    const mobileMenuExtraElement = panelContent.querySelector('.mobile-menu-extras');

                    if(mobileMenuExtraElement) {
                        mobileMenuExtras = mobileMenuExtraElement;
                    }else if(mobileMenuExtras) {
                        const panelDOMElement = document.getElementById(panel.id);
                        panelDOMElement.querySelector('.mm-listview').append(mobileMenuExtras);
                        // panelContent.appendChild(mobileMenuExtras);
                    }

                }
            }
        }, {
            // configuration
            offCanvas: {
                page: {
                    nodetype: 'main',
                    selector: mainContentSelector
                }
            },
            classNames: {
                selected: 'custom-mm-selected',
                panel: 'custom-mm-panel'
            }
        });

        // Init mmenu api
        const mmenuApi = menu.API;

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpointMaxM (768px)
        window.addEventListener('resize', e => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                const width = document.body.clientWidth;
                const mmIsOpened = document.querySelector('body').classList.contains('mm-wrapper_opening');
                if (mmenuApi && mmIsOpened && width > breakpointMaxM) {
                    mmenuApi.close();
                }
            }, 250);
        });
    };

    init();
}
